export default __webpack_public_path__ + "static/media/questions.b2b3d0da.png";